module.exports = __webpack_public_path__ + "media/images/press_kit/norwegian_cruise_line_holdings/email/top-light-small-e7cb4e7b1e2b87b4ab2c9ffb41dcff5b.png";